import IpAPI from "./ip"

// exports IP API
export default () => new IpAPI()